/* eslint-disable react/jsx-filename-extension */
/* eslint-disable camelcase */
import { DownloadOutlined } from '@ant-design/icons';

import { useState } from 'react';

import { Button, message, Space, Tag } from 'antd';
import { Link, useNavigate } from 'react-router-dom';

// eslint-disable-next-line import/no-cycle
import getRender from './getRender';
import apiConfig from '../../API_Utils/APIUtil/ApiConfig';
import CallApi from '../../API_Utils/APIUtil/CallApi';
import {
  DownloadViaLink,
  getColor,
  getDateFromISO,
  GetDateTimeFromISO,
  getError,
  getFormattedAmount,
  getFormattedNumber,
  getLabel,
  getTypeBasedSalesModelForSO
} from '../../clientUtils';
import { HoverCopy } from '../../Components/Common';
import Address from '../../Components/Common/Address';

/**
 * required
 PONo. -> po_number
 Brand -> brand
 Buyer -> buyer_billing
 Vendor -> seller
 Requested Qty -> ordered_qty
 Approved Qty -> pending_qty
 Amount -> amount
 Creation Date -> creation_date
 Expected Delivery Date -> delivery_date
 Updated On -> updated_on
 PO Type -> po_type
 Status -> state
 */

const getWidth = (type) => {
  const widthMap = {
    po_number: 200,
    asn_number: 200,
    grn_number: 200,
    buyer_billing: 200,
    seller: 200,
    pi_number: 200,
    requested_qty: 200,
    // received_quantity: 200,
    invoiced_quantity: 200,
    // invoice_quantity: 200,
    ordered_qty: 200,
    pending_qty: 200,
    amount: 180,
    invoice_amount: 180,
    invoiced_amount: 200,
    delivery_date: 180,
    expiry_date: 180,
    dispatch_date: 180,
    invoice_date: 180,
    po_type: 180,
    creation_date: 180,
    updated_on: 180,
    state: 140,
    received_allowable_grace_qty: 150,
    expected_delivery_date: 200,
    ro_number: 200,
    forward_invoice_number: 250,
    return_document_type: 200,
    document_date: 120,
    document_number: 200,
    total_invoiced_qty: 120,
    return_type: 180,
    seller_return_shipping_address_code: 250,
    actions: 200,
    inward_order_code: 200
  };
  return widthMap[type] || 120;
};

const getShippingTypeLabel = (type) => {
  const map = {
    DOMESTIC_PO_WH_SHIPPING: 'Warehouse Shipping',
    INTERNATIONAL_PO_DIRECT_SHIPPING: 'Direct Shipping',
    INTERNATIONAL_PO_WH_SHIPPING: 'Warehouse Shipping'
  };
  return map[type] ?? type;
};

const getExporterLabel = (type) => {
  const map = {
    MENSA: 'Mensa',
    VENDOR: 'Vendor'
  };
  return map[type] ?? type;
};

const POR = [
  {
    title: 'PO No.',
    dataIndex: 'po_number',
    key: 'po_number',
    width: getWidth('po_number'),
    ellipsis: true,
    fixed: 'left',
    render: (_, record) => (
      <a aria-label="po-redirection" href={`/purchases/purchase-request/${record.id}`}>
        <HoverCopy text={_} />
      </a>
    )
  },
  {
    title: 'Brand',
    dataIndex: 'brand',
    key: 'brand',
    width: getWidth('brand'),
    ellipsis: true
  },
  {
    title: 'Buyer',
    dataIndex: 'buyer_billing',
    key: 'buyer_billing',
    width: getWidth('buyer_billing')
  },
  {
    title: 'Vendor',
    dataIndex: 'seller',
    key: 'seller',
    ellipsis: true,
    width: getWidth('seller')
  },
  {
    title: 'Requested Qty',
    dataIndex: 'requested_qty',
    key: 'requested_qty',
    ellipsis: true,
    width: getWidth('requested_qty'),
    render: (_, record) => getFormattedNumber(record?.requested_qty)
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    ellipsis: true,
    width: getWidth('amount'),
    render: (_, record) => (
      <div>
        <span>{getFormattedAmount(record.currency, record.amount)}</span>{' '}
      </div>
    )
  },
  {
    title: 'Closure Date',
    dataIndex: 'delivery_date',
    key: 'delivery_date',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>,
    width: getWidth('delivery_date')
  },
  // {
  //   title: "Expiry Date",
  //   dataIndex: "expiry_date",
  //   key: "expiry_date",
  //   ellipsis: true,
  //   render: (date) => <span>{getDateFromISO(date)}</span>,
  //   width: getWidth("expiry_date"),
  // },
  {
    title: 'PO Type',
    dataIndex: 'po_type',
    key: 'po_type',
    ellipsis: true,
    width: getWidth('po_type'),
    render: (value) => <span>{getLabel(value)}</span>
  },
  {
    title: <span>Creation Date</span>,
    dataIndex: 'creation_date',
    key: 'creation_date',
    ellipsis: true,
    width: getWidth('creation_date'),
    render: (date) => <span>{GetDateTimeFromISO(date)}</span>
  },
  {
    title: 'Updated Date',
    dataIndex: 'updated_on',
    key: 'updated_on',
    ellipsis: true,
    width: getWidth('updated_on'),
    render: (date) => <span>{GetDateTimeFromISO(date)}</span>
  },
  {
    title: 'Status',
    dataIndex: 'state',
    key: 'state',
    ellipsis: true,
    width: getWidth('state'),
    render: (state) => <Status state={state} />
  }
];
// purchases/purchase-order/
const PO = [
  {
    title: 'PO No.',
    dataIndex: 'po_number',
    key: 'po_number',
    width: getWidth('po_number'),
    ellipsis: true,
    fixed: 'left',
    render: (_, record) => (
      <a aria-label="po-redirection" href={`/purchases/purchase-order/${record.id}`}>
        <HoverCopy text={_} />
      </a>
    )
  },
  {
    title: 'Brand',
    dataIndex: 'brand',
    key: 'brand',
    width: getWidth('brand'),
    ellipsis: true
  },
  {
    title: 'Buyer',
    dataIndex: 'buyer_billing',
    key: 'buyer_billing',
    width: getWidth('buyer_billing'),
    ellipsis: true
  },
  {
    title: (
      <span>
        {/* <Tooltip title="The vendor who is supplying the goods or services for this purchase order">
          <ExclamationCircleOutlined />
        </Tooltip>{" "} */}
        Vendor
      </span>
    ),
    dataIndex: 'seller',
    key: 'seller',
    width: getWidth('seller'),
    ellipsis: true
  },
  {
    title: 'Ordered Qty',
    dataIndex: 'ordered_qty',
    key: 'ordered_qty',
    width: getWidth('ordered_qty'),
    ellipsis: true,
    render: (_, record) => getFormattedNumber(record?.ordered_qty)
  },
  {
    title: 'Pending Qty',
    dataIndex: 'pending_qty',
    key: 'pending_qty',
    width: getWidth('pending_qty'),
    ellipsis: true,
    render: (_, record) => getFormattedNumber(record?.pending_qty)
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    width: getWidth('amount'),
    ellipsis: true,
    render: (_, record) => (
      <div>
        <span>{getFormattedAmount(record.currency, record.amount)}</span>
      </div>
    )
  },
  {
    title: (
      <span>
        {/* <Tooltip title="The creation date">
          <ExclamationCircleOutlined />
        </Tooltip>{" "} */}
        Creation Date
      </span>
    ),
    dataIndex: 'creation_date',
    key: 'creation_date',
    width: getWidth('creation_date'),
    ellipsis: true,
    render: (date) => <span>{GetDateTimeFromISO(date)}</span>
  },
  {
    title: 'Closure Date',
    dataIndex: 'delivery_date',
    key: 'delivery_date',
    width: getWidth('delivery_date'),
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>
  },
  {
    title: 'Updated Date',
    dataIndex: 'updated_on',
    key: 'updated_on',
    width: getWidth('updated_on'),
    ellipsis: true,
    render: (date) => <span>{GetDateTimeFromISO(date)}</span>
  },
  // {
  //   title: "Expiry Date",
  //   dataIndex: "expiry_date",
  //   key: "expiry_date",
  //   width: getWidth("expiry_date"),
  //   ellipsis: true,
  //   render: (date) => <span>{getDateFromISO(date)}</span>,
  // },
  {
    title: 'PO Type',
    dataIndex: 'po_type',
    key: 'po_type',
    width: getWidth('po_type'),
    ellipsis: true,
    render: (value) => <span>{getLabel(value)}</span>
  },
  {
    title: 'Status',
    dataIndex: 'state',
    key: 'state',
    width: getWidth('state'),
    ellipsis: true,
    render: (state) => <Status state={state} />
  }
];

/**
 * {
  "PO_No.": "PO No.",
  "brand": "Brand",
  "seller": "Seller",
  "buyer": "Buyer",
  "ordered_Qty": "Ordered Qty",
  "pending_Qty": "Pending Qty",
  "amount": "Amount",
  "creation_Date": "Creation Date",
  "expiry_Date": "Expiry Date",
  "delivery_Type": "Delivery Type",
  "sales_Model": "Sales Model",
  "PO_Туре": "PO Туре",
  "status": "Status"
}
 */

const CPL = [
  {
    title: 'PO No.',
    dataIndex: 'po_number',
    key: 'po_number',
    ellipsis: true,
    width: getWidth('po_number'),
    fixed: 'left',
    render: (_, record) => (
      <a aria-label="po-redirection" href={`/sales/customer-po/${record.id}`}>
        <HoverCopy text={_} />
      </a>
    )
  },
  {
    title: 'Brand',
    dataIndex: 'brand_names',
    key: 'brand_names',
    ellipsis: true,
    width: 182,
    render: (data) => (
      <span>{data ? data?.toString() : null}</span>
      // <span>{data?.reduce((pre, current) => `${pre},${current}`, "")}</span>
    )
  },
  {
    title: 'Seller',
    dataIndex: 'seller_name',
    key: 'seller_name',
    ellipsis: true,
    width: 144
  },
  {
    title: 'Buyer',
    dataIndex: 'buyer_name',
    key: 'buyer_name',
    ellipsis: true,
    width: 144
  },
  {
    title: 'Ordered Qty',
    dataIndex: 'quantity_details',
    key: 'quantity_details',
    ellipsis: true,
    width: 124,
    render: (data) => getFormattedNumber(data?.ordered)
  },
  {
    title: 'Pending Qty',
    dataIndex: 'quantity_details',
    key: 'quantity_details',
    ellipsis: true,
    width: 124,
    render: (data) => getFormattedNumber(data?.pending)
  },
  {
    title: 'Amount',
    dataIndex: 'total_payable_amount',
    key: 'total_payable_amount',
    ellipsis: true,
    width: 130,
    render: (_, record) => <span>{getFormattedAmount(undefined, record?.total_payable_amount)}</span>
  },
  {
    title: 'Delivery Type',
    dataIndex: 'delivery_type',
    key: 'delivery_type',
    ellipsis: true,
    width: 130,
    render: (date) => <span>{getLabel(date)}</span>
  },
  {
    title: 'Sales Model',
    dataIndex: 'sales_model',
    key: 'sales_model',
    ellipsis: true,
    width: getWidth('sales_model')
  },
  {
    title: 'PO Type',
    dataIndex: 'invoice_type',
    key: 'invoice_type',
    ellipsis: true,
    width: 140,
    render: (date) => <span>{getLabel(date)}</span>
  },
  {
    title: 'PO Date',
    dataIndex: 'po_date',
    key: 'po_date',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>,
    width: 140
  },
  {
    title: 'Closure Date',
    dataIndex: 'expiry_date',
    key: 'expiry_date',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>,
    width: 124
  },
  {
    title: 'Creation Date',
    dataIndex: 'created_on',
    key: 'created_on',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>,
    width: getWidth('created_on')
  },
  {
    title: 'Updated Date',
    dataIndex: 'updated_on',
    key: 'updated_on',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>,
    width: getWidth('updated_on')
  },
  {
    title: 'Status',
    dataIndex: 'state',
    key: 'state',
    ellipsis: true,
    render: (state) => <Status state={state} />
  }
];

const SOL = [
  {
    title: 'SO No.',
    dataIndex: 'so_number',
    key: 'so_number',
    ellipsis: true,
    width: 140,
    render: (_, record) => (
      <a aria-label="so-redirection" href={`/sales/domestic-sales-order/${record.id}`}>
        <HoverCopy text={_} />
      </a>
    ),
    fixed: 'left'
  },
  {
    title: 'Brand',
    dataIndex: 'brand_name',
    key: 'brand_name',
    ellipsis: true,
    width: 182,
    render: (value) => <span>{value?.join(', ')}</span>
  },
  {
    title: 'Seller',
    dataIndex: 'seller_name',
    key: 'seller_name',
    ellipsis: true,
    width: 140
  },
  {
    title: 'Buyer',
    dataIndex: 'buyer_name',
    key: 'buyer_name',
    ellipsis: true,
    width: 140
  },
  {
    title: 'Warehouse',
    dataIndex: 'ware_house',
    key: 'ware_house',
    ellipsis: true,
    width: 140
  },
  {
    title: 'Ordered Qty',
    dataIndex: 'quantity_details',
    key: 'quantity_details',
    ellipsis: true,
    width: 124,
    render: (value) => <span>{getFormattedNumber(value?.ordered)}</span>
  },
  {
    title: 'Packed Qty',
    dataIndex: 'quantity_details',
    key: 'quantity_details',
    ellipsis: true,
    width: 124,
    render: (value) => <span>{getFormattedNumber(value?.packed)}</span>
  },
  {
    title: 'Document Number',
    dataIndex: 'document_number',
    key: 'document_number',
    ellipsis: true,
    width: 135,
    render: getRender('hover')
  },
  {
    title: 'LR Number',
    dataIndex: 'lorry_receipt_number',
    key: 'lorry_receipt_number',
    ellipsis: true,
    width: 124
  },
  {
    title: 'Invoiced Qty',
    dataIndex: 'invoiced_quantity',
    key: 'invoiced_quantity',
    ellipsis: true,
    width: 124
  },
  {
    title: 'Invoice Date',
    dataIndex: 'invoice_date',
    key: 'invoice_date',
    ellipsis: true,
    width: 124,
    render: (date) => <span>{getDateFromISO(date)}</span>
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    ellipsis: true,
    width: 124,
    render: (_, record) => <span>{getFormattedAmount(record?.currency, record.amount)}</span>
  },
  {
    title: 'Sales Model',
    dataIndex: 'sales_model',
    key: 'sales_model',
    ellipsis: true,
    width: 140,
    render: (_, record) => <span>{getTypeBasedSalesModelForSO(record?.so_type, record?.sales_model)}</span>
  },
  {
    title: 'PO Number',
    dataIndex: 'po_number',
    key: 'po_number',
    ellipsis: true,
    width: 140,
    render: (data) => <span>{data || 'NA'}</span>
  },
  {
    title: 'SO Type',
    dataIndex: 'so_type',
    key: 'so_type',
    ellipsis: true,
    width: 140,
    render: (type) => <span>{getLabel(type)}</span>
  },
  {
    title: (
      <span>
        {/* <Tooltip title="The creation date">
          <ExclamationCircleOutlined />
        </Tooltip>{" "} */}
        Creation Date
      </span>
    ),
    dataIndex: 'creation_date',
    key: 'creation_date',
    ellipsis: true,
    width: 124,
    render: (date) => <span>{getDateFromISO(date)}</span>
  },
  {
    title: 'Updated Date',
    dataIndex: 'updated_date',
    key: 'updated_date',
    ellipsis: true,
    width: 124,
    render: (date) => <span>{getDateFromISO(date)}</span>
  },
  {
    title: 'Status',
    dataIndex: 'state',
    key: 'state',
    ellipsis: true,
    width: 140,
    render: (state) => <Status state={state} />
  }
];

const ISOL = [
  {
    title: 'SO No.',
    dataIndex: 'eo_number',
    key: 'eo_number',
    ellipsis: true,
    width: 140,
    render: (_, record) => (
      <a aria-label="international-sales-order" href={`/sales/international-sales-order/${record.id}`}>
        <HoverCopy text={_} />
      </a>
    ),
    fixed: 'left'
  },
  {
    title: 'Brand',
    dataIndex: 'brand',
    key: 'brand',
    ellipsis: true,
    width: 182,
    render: (value) => {
      return <span>{Array.isArray(value) ? value?.join(', ') : '-'}</span>;
    }
  },
  {
    title: 'Seller',
    dataIndex: 'seller',
    key: 'seller',
    ellipsis: true,
    width: 140
  },
  {
    title: 'Buyer',
    dataIndex: 'buyer',
    key: 'buyer',
    ellipsis: true,
    width: 140
  },
  {
    title: 'Warehouse',
    dataIndex: 'ware_house',
    key: 'ware_house',
    ellipsis: true,
    width: 140
  },
  {
    title: 'Ordered Qty',
    dataIndex: 'ordered_quantity',
    key: 'ordered_quantity',
    ellipsis: true,
    width: 124
  },
  {
    title: 'Packed Qty',
    dataIndex: 'packed_quantity',
    key: 'packed_quantity',
    ellipsis: true,
    width: 124
  },
  {
    title: 'Document Number',
    dataIndex: 'document_number',
    key: 'document_number',
    ellipsis: true,
    width: 135,
    render: getRender('hover')
  },
  {
    title: 'FBA Ids',
    dataIndex: 'fba_ids',
    key: 'fba_ids',
    ellipsis: true,
    width: 135,
    render: getRender('hover')
  },
  {
    title: 'Invoiced Qty',
    dataIndex: 'invoiced_quantity',
    key: 'invoiced_quantity',
    ellipsis: true,
    width: 124
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    ellipsis: true,
    width: 124,
    render: (_, record) => <span>{getFormattedAmount(record.currency, record.amount)}</span>
  },
  {
    title: 'Sales Model',
    dataIndex: 'sales_model',
    key: 'sales_model',
    ellipsis: true,
    width: 140,
    render: (_, record) => <span>{getLabel(record?.sales_model)}</span>
  },
  {
    title: 'PO Number',
    dataIndex: 'po_number',
    key: 'po_number',
    ellipsis: true,
    width: 140,
    render: (data) => <span>{data || 'NA'}</span>
  },
  {
    title: 'SO Type',
    dataIndex: 'type',
    key: 'type',
    ellipsis: true,
    width: 140,
    render: (type) => <span>{getLabel(type)}</span>
  },
  {
    title: (
      <span>
        {/* <Tooltip title="The creation date">
          <ExclamationCircleOutlined />
        </Tooltip>{" "} */}
        Creation Date
      </span>
    ),
    dataIndex: 'creation_date',
    key: 'creation_date',
    ellipsis: true,
    width: 124,
    render: (date) => <span>{getDateFromISO(date)}</span>
  },
  {
    title: 'Updated Date',
    dataIndex: 'updated_date',
    key: 'updated_date',
    ellipsis: true,
    width: 124,
    render: (date) => <span>{getDateFromISO(date)}</span>
  },
  {
    title: 'Status',
    dataIndex: 'state',
    key: 'state',
    ellipsis: true,
    width: 140,
    render: (state) => <Status state={state} />
  }
];

const POGRN = [
  {
    title: 'GRN No.',
    dataIndex: 'grn_number',
    key: 'grn_number',
    width: getWidth('grn_number'),
    ellipsis: true,
    fixed: 'left',
    render: (_, record) => (
      <a aria-label="grn-redirection" href={`/purchases/grn/${record.id}`}>
        <HoverCopy text={_} />
      </a>
    )
  },
  {
    title: 'PO No.',
    dataIndex: 'po_number',
    key: 'po_number',
    width: getWidth('po_number'),
    ellipsis: true,
    render: getRender('hover')
  },
  {
    title: 'ASN No.',
    dataIndex: 'asn_number',
    key: 'asn_number',
    width: getWidth('asn_number'),
    ellipsis: true,
    render: getRender('hover')
  },
  {
    title: 'Invoice No.',
    dataIndex: 'invoice_number',
    key: 'invoice_number',
    width: getWidth('invoice_number'),
    ellipsis: true,
    render: getRender('hover')
  },
  {
    dataIndex: 'invoiced_amount',
    key: 'invoiced_amount',
    width: getWidth('invoiced_amount'),
    title: 'Invoice Amount',
    ellipsis: true,
    render: (_, record) => (
      <div>
        <span>{getFormattedAmount(record?.currency, record?.invoice_amount)}</span>{' '}
      </div>
    )
  },
  {
    title: 'Invoice Qty',
    dataIndex: 'invoice_quantity',
    key: 'invoice_quantity',
    width: getWidth('invoice_quantity'),
    ellipsis: true,
    render: (data) => getFormattedNumber(data)
  },
  {
    title: 'Received Qty',
    dataIndex: 'received_quantity',
    key: 'received_quantity',
    width: getWidth('received_quantity'),
    ellipsis: true,
    render: (value) => getFormattedNumber(value)
  },
  {
    title: 'QC Pass Qty',
    dataIndex: 'qc_pass_quantity',
    key: 'qc_pass_quantity',
    width: getWidth('qc_pass_quantity'),
    ellipsis: true,
    render: (value) => getFormattedNumber(value)
  },
  {
    title: 'QC Fail Qty',
    dataIndex: 'qc_fail_quantity',
    key: 'qc_fail_quantity',
    width: getWidth('qc_fail_quantity'),
    ellipsis: true,
    render: (value) => getFormattedNumber(value)
  },
  {
    title: 'Short Qty',
    dataIndex: 'short_quantity',
    key: 'short_quantity',
    width: getWidth('short_quantity'),
    ellipsis: true,
    render: (value) => getFormattedNumber(value)
  },
  {
    title: 'Excess Qty',
    dataIndex: 'excess_quantity',
    key: 'excess_quantity',
    width: getWidth('excess_quantity'),
    ellipsis: true,
    render: (value) => getFormattedNumber(value)
  },
  {
    title: 'Grace Qty',
    dataIndex: 'received_allowable_grace_qty',
    key: 'received_allowable_grace_qty',
    width: getWidth('received_allowable_grace_qty'),
    ellipsis: true,
    render: (value) => getFormattedNumber(value)
  },
  {
    title: 'Creation Date',
    dataIndex: 'creation_date',
    key: 'creation_date',
    width: getWidth('creation_date'),
    ellipsis: true,
    render: (date) => <span>{GetDateTimeFromISO(date)}</span>
  },
  {
    title: 'Updated Date',
    dataIndex: 'updated_on',
    key: 'updated_on',
    width: getWidth('updated_on'),
    ellipsis: true,
    render: (date) => <span>{GetDateTimeFromISO(date)}</span>
  },
  {
    title: 'GRN Type',
    dataIndex: 'grn_type',
    key: 'grn_type',
    width: getWidth('grn_type'),
    ellipsis: true,
    render: (state) => <span>{getLabel(state)}</span>
  },
  {
    title: 'Status',
    dataIndex: 'state',
    key: 'state',
    width: getWidth('state'),
    ellipsis: true,
    render: (state) => <Status state={state} />
  }
];

const POASN = [
  {
    dataIndex: 'asn_number',
    key: 'asn_number',
    width: getWidth('asn_number'),
    title: 'ASN No.',
    ellipsis: true,
    fixed: 'left',
    render: (_, record) => (
      <a aria-label="asn-redirection" href={`/purchases/asn/${record.id}`}>
        <HoverCopy text={_} />
      </a>
    )
  },
  {
    dataIndex: 'po_number',
    key: 'po_number',
    width: getWidth('po_number'),
    title: 'PO No.',
    ellipsis: true,
    render: getRender('hover')
  },
  {
    dataIndex: 'pi_number',
    key: 'pi_number',
    width: getWidth('pi_number'),
    title: 'Invoice No.',
    ellipsis: true,
    render: getRender('hover')
  },
  {
    dataIndex: 'brand',
    key: 'brand',
    width: getWidth('brand'),
    title: 'Brand',
    ellipsis: true
  },
  {
    dataIndex: 'seller',
    key: 'seller',
    width: getWidth('seller'),
    title: 'Vendor',
    ellipsis: true
  },
  {
    dataIndex: 'warehouse',
    key: 'warehouse',
    width: getWidth('warehouse'),
    title: 'Warehouse',
    ellipsis: true
  },
  {
    dataIndex: 'shipping_type',
    key: 'shipping_type',
    width: getWidth('shipping_type'),
    title: 'Shipping Type',
    ellipsis: true,
    render: (shipping_type) => <span>{getShippingTypeLabel(shipping_type)}</span>
  },
  {
    dataIndex: 'exporter',
    key: 'exporter',
    width: getWidth('exporter'),
    title: 'Exporter',
    ellipsis: true,
    render: (exporter) => <span>{getExporterLabel(exporter)}</span>
  },
  {
    dataIndex: 'invoiced_quantity',
    key: 'invoiced_quantity',
    width: getWidth('invoiced_quantity'),
    title: 'Invoice Qty',
    ellipsis: true
  },
  {
    dataIndex: 'invoice_amount',
    key: 'invoice_amount',
    width: getWidth('invoice_amount'),
    title: 'Invoice Amount (Incl Tax)',
    ellipsis: true,

    render: (_, record) => <span>{getFormattedAmount(record?.currency, record?.invoice_amount)}</span>
  },
  {
    dataIndex: 'box_count',
    key: 'box_count',
    width: getWidth('box_count'),
    title: 'Box Count',
    ellipsis: true
  },
  {
    dataIndex: 'invoice_date',
    key: 'invoice_date',
    width: getWidth('invoice_date'),
    title: 'Invoice Date',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>
  },
  {
    dataIndex: 'approved_delivery_date',
    key: 'approved_delivery_date',
    width: getWidth('expected_delivery_date'),
    title: 'Approved Delivery Date',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>
  },
  {
    dataIndex: 'expected_delivery_date',
    key: 'expected_delivery_date',
    width: getWidth('expected_delivery_date'),
    title: 'Expected Delivery Date',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>
  },
  {
    dataIndex: 'expected_dispatch_date',
    key: 'expected_dispatch_date',
    width: getWidth('dispatch_date'),
    title: 'Expected Dispatch Date',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>
  },
  {
    dataIndex: 'dispatch_date',
    key: 'dispatch_date',
    width: getWidth('dispatch_date'),
    title: 'Actual Dispatch Date',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>
  },
  {
    dataIndex: 'actual_delivery_date',
    key: 'actual_delivery_date',
    width: getWidth('dispatch_date'),
    title: 'Actual Delivery Date',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>
  },
  {
    dataIndex: 'creation_date',
    key: 'creation_date',
    width: getWidth('creation_date'),
    title: 'Creation Date',
    ellipsis: true,
    render: (date) => <span>{GetDateTimeFromISO(date)}</span>
  },
  {
    dataIndex: 'updated_on',
    key: 'updated_on',
    width: getWidth('updated_on'),
    title: 'Updated Date',
    ellipsis: true,
    render: (date) => <span>{GetDateTimeFromISO(date)}</span>
  },
  {
    title: 'Status',
    dataIndex: 'state',
    key: 'state',
    width: getWidth('state'),
    ellipsis: true,
    render: (state) => <Status state={state} />
  }
];

const PO_RO = [
  {
    key: 'ro_number',
    width: getWidth('ro_number'),
    title: 'RO Number',
    dataIndex: 'ro_number',
    fixed: 'left',
    render: (_, record) => (
      <Link aria-label="sales-grn" to={`/purchases/return-order/details/${record.id}`}>
        <HoverCopy text={_} />
      </Link>
    )
  },
  {
    key: 'forward_invoice_number',
    width: getWidth('forward_invoice_number'),
    title: 'FW Invoice Number',
    dataIndex: 'forward_invoice_number'
  },
  {
    key: 'forward_order_number',
    width: getWidth('forward_invoice_number'),
    title: 'PO Number',
    dataIndex: 'forward_order_number'
  },
  {
    key: 'lr_number',
    width: getWidth('forward_invoice_number'),
    title: 'LR Number',
    dataIndex: 'lr_number'
  },
  {
    key: 'awb_number',
    width: getWidth('forward_invoice_number'),
    title: 'AWB Number',
    dataIndex: 'awb_number'
  },
  {
    key: 'rto_date',
    width: getWidth('document_date'),
    title: 'RTO Date',
    dataIndex: 'rto_date',
    render: (date) => <span>{getDateFromISO(date)}</span>
  },
  {
    key: 'order_type',
    width: getWidth('return_document_type'),
    title: 'RO Type',
    dataIndex: 'order_type'
  },
  {
    key: 'document_date',
    width: getWidth('document_date'),
    title: 'Document Date',
    dataIndex: 'document_date',
    render: (date) => <span>{getDateFromISO(date)}</span>
  },
  {
    key: 'document_number',
    width: getWidth('document_number'),
    title: 'Document Number',
    dataIndex: 'document_number'
  },
  {
    key: 'total_order_quantity',
    width: getWidth('total_ordered_qty'),
    title: 'Order Qty',
    dataIndex: 'total_order_quantity'
  },
  {
    key: 'return_type',
    width: getWidth('return_type'),
    title: 'Return Type',
    dataIndex: 'return_type'
  },
  {
    key: 'seller_return_shipping_address_code',
    width: getWidth('seller_return_shipping_address_code'),
    title: 'Seller Return Shipping Address Code',
    dataIndex: 'seller_return_shipping_address_code'
  },
  {
    key: 'status',
    width: getWidth('status'),
    title: 'Status',
    dataIndex: 'status',
    render: (state) => <Status state={state} />
  },
  {
    title: 'Creation Date',
    dataIndex: 'creation_date',
    key: 'creation_date',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>,
    width: 124
  },
  {
    title: 'Updated Date',
    dataIndex: 'updated_date',
    key: 'updated_date',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>,
    width: 124
  }
];

const SODGRN = [
  {
    title: 'GRN No.',
    dataIndex: 'grn_number',
    key: 'grn_number',
    ellipsis: true,
    width: 124,
    fixed: 'left',
    render: (_, record) => (
      <a aria-label="grn-redirection" href={`/sales/domestic-grn/${record.id}`}>
        <HoverCopy text={_} />
      </a>
    )
  },
  {
    title: 'PO No.',
    dataIndex: 'po_number',
    key: 'po_number',
    ellipsis: true,
    width: 124,
    render: getRender('hover')
  },
  {
    title: 'SO No.',
    dataIndex: 'so_number_list',
    key: 'so_number_list',
    ellipsis: true,
    width: 140,
    render: (data) => <HoverCopy text={data?.join(', ')} />
  },
  // {
  //   title: 'Inward Order Number',
  //   dataIndex: 'inward_order_number',
  //   key: 'inward_order_number',
  //   ellipsis: true,
  //   width: 140,
  //   render: getRender('hover')
  // },
  {
    title: 'Invoiced Qty',
    dataIndex: 'total_invoiced_qty',
    key: 'total_invoiced_qty',
    ellipsis: true,
    width: 140,
    render: (_, record) => getFormattedNumber(record?.total_invoiced_qty)
  },
  {
    title: 'Received Qty',
    dataIndex: 'total_received_qty',
    key: 'total_received_qty',
    ellipsis: true,
    width: 124,
    render: (data) => getFormattedNumber(data)
  },
  {
    title: 'QC Pass Qty',
    dataIndex: 'total_qc_pass_qty',
    key: 'total_qc_pass_qty',
    ellipsis: true,
    width: 124,
    render: (data) => getFormattedNumber(data)
  },
  {
    title: 'QC Fail Qty',
    dataIndex: 'total_qc_fail_qty',
    key: 'total_qc_fail_qty',
    ellipsis: true,
    width: 124,
    render: (data) => getFormattedNumber(data)
  },
  {
    title: 'Excess Qty',
    dataIndex: 'total_excess_qty',
    key: 'total_excess_qty',
    ellipsis: true,
    width: 124,
    render: (data) => getFormattedNumber(data)
  },
  {
    title: 'Short Qty',
    dataIndex: 'total_short_qty',
    key: 'total_short_qty',
    ellipsis: true,
    width: 124,
    render: (data) => getFormattedNumber(data)
  },
  {
    title: 'Creation Date',
    dataIndex: 'created_on',
    key: 'created_on',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>,
    width: 124
  },
  {
    title: 'Updated Date',
    dataIndex: 'updated_on',
    key: 'updated_on',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>,
    width: 124
  },
  {
    title: 'GRN Type',
    dataIndex: 'grn_type',
    key: 'grn_type',
    ellipsis: true,
    width: 151,
    render: (state) => <span>{getLabel(state)}</span>
  },
  {
    title: 'Status',
    dataIndex: 'grn_status',
    key: 'grn_status',
    width: getWidth('state'),
    ellipsis: true,
    render: (state) => <Status state={state} />
  }
];
const SOIGRN = [
  {
    title: 'GRN No.',
    dataIndex: 'grn_number',
    key: 'grn_number',
    ellipsis: true,
    width: 124,
    fixed: 'left',
    render: (_, record) => (
      <a aria-label="sales-grn" href={`/sales/international-grn/${record.id}`}>
        <HoverCopy text={_} />
      </a>
    )
  },
  {
    title: 'PO No.',
    dataIndex: 'po_number',
    key: 'po_number',
    ellipsis: true,
    width: 124,
    render: getRender('hover')
  },
  {
    title: 'SO No.',
    dataIndex: 'eo_number',
    key: 'eo_number',
    ellipsis: true,
    width: 140,
    render: (data) => <HoverCopy text={data} />
  },
  // {
  //   title: 'Inward Order Number',
  //   dataIndex: 'inward_order_number',
  //   key: 'inward_order_number',
  //   ellipsis: true,
  //   width: 140,
  //   render: getRender('hover')
  // },
  {
    title: 'Invoiced Qty',
    dataIndex: 'total_invoiced_qty',
    key: 'total_invoiced_qty',
    ellipsis: true,
    width: 140,
    render: (_, record) => getFormattedNumber(record?.total_invoiced_qty)
  },
  {
    title: 'Received Qty',
    dataIndex: 'total_received_qty',
    key: 'total_received_qty',
    ellipsis: true,
    width: 124,
    render: (data) => getFormattedNumber(data)
  },
  {
    title: 'QC Pass Qty',
    dataIndex: 'total_qc_pass_qty',
    key: 'total_qc_pass_qty',
    ellipsis: true,
    width: 124,
    render: (data) => getFormattedNumber(data)
  },
  {
    title: 'QC Fail Qty',
    dataIndex: 'total_qc_fail_qty',
    key: 'total_qc_fail_qty',
    ellipsis: true,
    width: 124,
    render: (data) => getFormattedNumber(data)
  },
  {
    title: 'Excess Qty',
    dataIndex: 'total_excess_qty',
    key: 'total_excess_qty',
    ellipsis: true,
    width: 124,
    render: (data) => getFormattedNumber(data)
  },
  {
    title: 'Short Qty',
    dataIndex: 'total_short_qty',
    key: 'total_short_qty',
    ellipsis: true,
    width: 124,
    render: (data) => getFormattedNumber(data)
  },
  {
    title: 'Creation Date',
    dataIndex: 'created_on',
    key: 'created_on',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>,
    width: 124
  },
  {
    title: 'Updated Date',
    dataIndex: 'updated_on',
    key: 'updated_on',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>,
    width: 124
  },
  {
    title: 'GRN Type',
    dataIndex: 'type',
    key: 'type',
    ellipsis: true,
    width: 151,
    render: (state) => <span>{getLabel(state)}</span>
  },
  {
    title: 'Status',
    dataIndex: 'state',
    key: 'state',
    width: getWidth('state'),
    ellipsis: true,
    render: (state) => <Status state={state} />
  }
];

const OPEN_PO_ASN = [
  {
    title: 'PO No.',
    dataIndex: 'po_number',
    key: 'po_number',
    width: getWidth('po_number'),
    fixed: 'left'
  },
  {
    title: 'ASN No.',
    dataIndex: 'asn_number',
    key: 'asn_number',
    width: getWidth('asn_number')
  },
  {
    title: 'PO No.',
    dataIndex: 'po_number',
    key: 'po_number',
    width: getWidth('po_number')
  },
  {
    title: 'Invoice No.',
    dataIndex: 'pi_number',
    key: 'pi_number',
    width: getWidth('pi_number')
  },
  {
    title: 'Invoiced Qty',
    dataIndex: 'invoiced_quantity',
    key: 'invoiced_quantity',
    width: getWidth('invoiced_quantity')
  },
  {
    title: 'Box Count',
    dataIndex: 'no_of_boxes',
    key: 'no_of_boxes',
    width: getWidth('no_of_boxes')
  },
  {
    title: 'Delivery Date',
    dataIndex: 'delivery_date',
    key: 'delivery_date',
    width: getWidth('delivery_date'),
    render: (date) => <span>{getDateFromISO(date)}</span>
  },
  {
    title: 'Status',
    dataIndex: 'state',
    key: 'state',
    width: getWidth('state'),
    ellipsis: true,
    render: (state) => <Status state={state} />
  }
];

const OPEN_PO_GRN = [
  {
    title: 'GRN No.',
    dataIndex: 'grn_number',
    key: 'grn_number',
    width: getWidth('grn_number'),
    fixed: 'left'
  },
  {
    title: 'PO No.',
    dataIndex: 'po_number',
    key: 'po_number',
    width: getWidth('po_number')
  },
  {
    title: 'ASN No.',
    dataIndex: 'asn_number',
    key: 'asn_number',
    width: getWidth('asn_number')
  },
  {
    title: 'Received Qty',
    dataIndex: 'received_quantity',
    key: 'received_quantity',
    width: getWidth('received_quantity')
  },
  {
    title: 'QC Pass Qty',
    dataIndex: 'qc_pass_quantity',
    key: 'qc_pass_quantity',
    width: getWidth('qc_pass_quantity')
  },
  {
    title: 'QC Fail Qty',
    dataIndex: 'qc_fail_quantity',
    key: 'qc_fail_quantity',
    width: getWidth('qc_fail_quantity')
  },
  {
    title: ' Short Qty',
    dataIndex: 'short_quantity',
    key: 'short_quantity',
    width: getWidth('short_quantity')
  },
  {
    title: 'Excess Qty',
    dataIndex: 'excess_quantity',
    key: 'excess_quantity',
    width: getWidth('excess_quantity')
  }
];

const INV = [
  {
    title: 'SKU Id',
    dataIndex: 'sku_id',
    key: 'sku_id',
    fixed: 'left',
    render: getRender('hover')
  },
  // {
  //   title: "Available Qty",
  //   dataIndex: "available_qty",
  //   key: "available_qty",
  //   width: 150,
  // },
  {
    title: 'QC Pass Qty',
    dataIndex: 'qc_pass_quantity',
    key: 'qc_pass_quantity',
    width: getWidth('qc_pass_quantity')
  },
  {
    title: 'QC Fail Qty',
    dataIndex: 'qc_fail_quantity',
    key: 'qc_fail_quantity',
    width: getWidth('qc_fail_quantity')
  },
  {
    title: 'Excess Qty',
    dataIndex: 'excess_quantity',
    key: 'excess_quantity',
    width: getWidth('excess_quantity')
  },
  {
    title: 'Facility Code',
    dataIndex: 'facility',
    key: 'facility'
  },
  {
    title: 'Facility Address',
    dataIndex: 'facility_address',
    key: 'facility_address',
    render: (data) => <Address entity={{ ...data, gst_number: undefined, wms: undefined }} />
  },
  {
    title: 'Facility Type',
    dataIndex: 'facility_address_type',
    key: 'facility_address_type',
    render: (value) => <span>{getLabel(value)}</span>
  },
  {
    title: 'Vendor',
    dataIndex: 'vendor',
    key: 'vendor'
  },
  {
    title: 'PO No.',
    dataIndex: 'po_number',
    key: 'po_number',
    render: getRender('hover')
  },
  {
    title: 'PI No.',
    dataIndex: 'pi_number',
    key: 'pi_number',
    render: getRender('hover')
  },
  {
    title: 'PO Type',
    dataIndex: 'po_type',
    key: 'po_type',
    render: (value) => <span>{getLabel(value)}</span>
  },
  {
    title: 'PO Date',
    dataIndex: 'po_date',
    key: 'po_date',
    render: (date) => <span>{getDateFromISO(date)}</span>
  },
  {
    title: 'PI Date',
    dataIndex: 'pi_date',
    key: 'pi_date',
    render: (date) => <span>{getDateFromISO(date)}</span>
  },
  {
    title: 'Excess Qty',
    dataIndex: 'excess_quantity',
    key: 'excess_quantity',
    width: getWidth('excess_quantity')
  }
];

/*
const RO = [
  {
    title: 'RO Number',
    dataIndex: 'ro_number',
    key: 'ro_number',
    fixed: 'left',
    render: getRender('hover')
  },
  {
    title: 'Brand',
    dataIndex: 'brand',
    key: 'brand',
    ellipsis: true,
    width: 182,
    render: (value) => <span>{value?.join(', ')}</span>
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    ellipsis: true
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    ellipsis: true
  },
  {
    title: 'Qty',
    dataIndex: 'ordered_qty',
    key: 'ordered_qty',
    ellipsis: true
  },
  {
    title: 'Buyer Billing',
    dataIndex: 'buyer_billing',
    key: 'buyer_billing',
    ellipsis: true
  },
  {
    title: 'Buyer Billing',
    dataIndex: 'buyer_billing',
    key: 'buyer_billing',
    ellipsis: true
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    ellipsis: true,
    width: getWidth('po_type'),
    render: (value) => <span>{getLabel(value)}</span>
  },
  {
    title: 'Status',
    dataIndex: 'state',
    key: 'state',
    ellipsis: true,
    width: getWidth('state'),
    render: (state) => <Status state={state} />
  }
];
*/

const RO = [
  {
    key: 'ro_number',
    width: getWidth('ro_number'),
    title: 'RO Number',
    dataIndex: 'ro_number',
    fixed: 'left',
    render: (_, record) => (
      <Link aria-label="sales-grn" to={`/sales/return/${record.id}`}>
        <HoverCopy text={_} />
      </Link>
    )
  },
  {
    key: 'inward_order_code',
    width: getWidth('inward_order_code'),
    title: 'Inward Order Code',
    dataIndex: 'inward_order_code',
    render: (_) => <HoverCopy text={_} />
  },
  {
    key: 'forward_invoice_number',
    width: getWidth('forward_invoice_number'),
    title: 'FW Invoice Number',
    dataIndex: 'forward_invoice_number'
  },
  {
    key: 'forward_order_number',
    width: getWidth('forward_invoice_number'),
    title: 'SO Number',
    dataIndex: 'forward_order_number'
  },
  {
    key: 'lr_number',
    width: getWidth('forward_invoice_number'),
    title: 'LR Number',
    dataIndex: 'lr_number'
  },
  {
    key: 'cn_number',
    width: getWidth('forward_invoice_number'),
    title: 'CN Number',
    dataIndex: 'cn_number'
  },
  {
    key: 'awb_number',
    width: getWidth('forward_invoice_number'),
    title: 'AWB Number',
    dataIndex: 'awb_number'
  },
  {
    render: (date) => <span>{getDateFromISO(date)}</span>
  },
  {
    key: 'open_date',
    width: getWidth('document_date'),
    title: 'Open Date',
    dataIndex: 'open_date',
    render: (date, record) => <span>{getDateFromISO(date || record?.openDate)}</span>
  },
  {
    key: 'return_document_type',
    width: getWidth('return_document_type'),
    title: 'Document Type',
    dataIndex: 'return_document_type'
  },
  {
    key: 'sales_model',
    width: getWidth('return_document_type'),
    title: 'Sales Model',
    dataIndex: 'sales_model'
  },
  {
    key: 'order_type',
    width: getWidth('return_document_type'),
    title: 'RO Type',
    dataIndex: 'order_type'
  },
  {
    key: 'document_date',
    width: getWidth('document_date'),
    title: 'Document Date',
    dataIndex: 'document_date',
    render: (date) => <span>{getDateFromISO(date)}</span>
  },
  {
    key: 'document_number',
    width: getWidth('document_number'),
    title: 'Document Number',
    dataIndex: 'document_number'
  },
  {
    key: 'total_order_quantity',
    width: getWidth('total_ordered_qty'),
    title: 'Order Qty',
    dataIndex: 'total_order_quantity'
  },
  {
    key: 'return_type',
    width: getWidth('return_type'),
    title: 'Return Type',
    dataIndex: 'return_type'
  },
  {
    key: 'seller_return_shipping_address_code',
    width: getWidth('seller_return_shipping_address_code'),
    title: 'Seller Return Shipping Address Code',
    dataIndex: 'seller_return_shipping_address_code'
  },
  {
    key: 'status',
    width: getWidth('status'),
    title: 'Status',
    dataIndex: 'status',
    render: (state) => <Status state={state} />
  },
  {
    title: 'Creation Date',
    dataIndex: 'creation_date',
    key: 'creation_date',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>,
    width: 124
  },
  {
    title: 'Updated Date',
    dataIndex: 'updated_date',
    key: 'updated_date',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>,
    width: 124
  }
];

const RO_GRN = [
  {
    title: 'GRN No.',
    dataIndex: 'grn_number',
    key: 'grn_number',
    ellipsis: true,
    width: 124,
    fixed: 'left',
    render: (_, record) => (
      <a aria-label="grn-redirection" href={`/sales/ro-grn/${record.id}`}>
        <HoverCopy text={_} />
      </a>
    )
  },
  // {
  //   title: 'PO No.',
  //   dataIndex: 'po_number',
  //   key: 'po_number',
  //   ellipsis: true,
  //   width: 124,
  //   render: getRender('hover')
  // },
  // {
  //   title: 'SO No.',
  //   dataIndex: 'so_number_list',
  //   key: 'so_number_list',
  //   ellipsis: true,
  //   width: 140,
  //   render: (data) => <HoverCopy text={data?.join(', ')} />
  // },
  // {
  //   title: 'Inward Order Number',
  //   dataIndex: 'inward_order_number',
  //   key: 'inward_order_number',
  //   ellipsis: true,
  //   width: 140,
  //   render: getRender('hover')
  // },
  {
    title: 'Invoiced Qty',
    dataIndex: 'total_invoiced_qty',
    key: 'total_invoiced_qty',
    ellipsis: true,
    width: 140,
    render: (_, record) => getFormattedNumber(record?.total_invoiced_qty)
  },
  {
    title: 'Received Qty',
    dataIndex: 'total_received_qty',
    key: 'total_received_qty',
    ellipsis: true,
    width: 124,
    render: (data) => getFormattedNumber(data)
  },
  {
    title: 'QC Pass Qty',
    dataIndex: 'total_qc_pass_qty',
    key: 'total_qc_pass_qty',
    ellipsis: true,
    width: 124,
    render: (data) => getFormattedNumber(data)
  },
  {
    title: 'QC Fail Qty',
    dataIndex: 'total_qc_fail_qty',
    key: 'total_qc_fail_qty',
    ellipsis: true,
    width: 124,
    render: (data) => getFormattedNumber(data)
  },
  {
    title: 'Excess Qty',
    dataIndex: 'total_excess_qty',
    key: 'total_excess_qty',
    ellipsis: true,
    width: 124,
    render: (data) => getFormattedNumber(data)
  },
  {
    title: 'Short Qty',
    dataIndex: 'total_short_qty',
    key: 'total_short_qty',
    ellipsis: true,
    width: 124,
    render: (data) => getFormattedNumber(data)
  },
  {
    title: 'Creation Date',
    dataIndex: 'created_on',
    key: 'created_on',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>,
    width: 124
  },
  {
    title: 'Updated Date',
    dataIndex: 'updated_on',
    key: 'updated_on',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>,
    width: 124
  },
  // {
  //   title: 'GRN Type',
  //   dataIndex: 'grn_type',
  //   key: 'grn_type',
  //   ellipsis: true,
  //   width: 151,
  //   render: (state) => <span>{getLabel(state)}</span>
  // },
  {
    title: 'Status',
    dataIndex: 'grn_status',
    key: 'grn_status',
    width: getWidth('state'),
    ellipsis: true,
    render: (state) => <Status state={state} />
  }
];

const USERS = [
  {
    title: 'Name',
    key: 'name',
    dataIndex: 'name',
    ellipsis: true
    // render: (record) => `${record?.first_name ?? '-'} ${record?.last_name ?? ''}`
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    ellipsis: true,
    width: getWidth('email')
  },
  {
    title: 'Permissions',
    dataIndex: 'permissions',
    key: 'permissions',
    ellipsis: true,
    width: getWidth('permissions')
  },
  {
    title: 'Creation By',
    dataIndex: 'created_by',
    key: 'created_by',
    ellipsis: true,
    width: getWidth('created_by')
  },
  {
    title: 'Creation Date',
    dataIndex: 'created_on',
    key: 'created_on',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>,
    width: getWidth('created_on')
  },
  {
    title: 'Updated Date',
    dataIndex: 'updated_on',
    key: 'updated_on',
    ellipsis: true,
    render: (date) => <span>{getDateFromISO(date)}</span>,
    width: getWidth('updated_on')
  }
];

const COGS = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    ellipsis: true,
    width: getWidth('id')
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    ellipsis: true,
    width: getWidth('status'),
    render: (state) => <Status state={state} />
  },
  {
    title: 'File',
    dataIndex: 'file_link',
    key: 'file_link',
    ellipsis: true,
    width: getWidth('file_link'),
    render: (link) => <Button icon={<DownloadOutlined />} onClick={() => DownloadViaLink(link)} type="link" />
  },
  {
    title: 'Created By',
    dataIndex: 'created_by',
    key: 'created_by',
    ellipsis: true,
    width: getWidth('created_by')
  },
  {
    title: 'Created At',
    dataIndex: 'created_on',
    key: 'created_on',
    ellipsis: true,
    render: (date) => <span>{GetDateTimeFromISO(date)}</span>,
    width: getWidth('created_on')
  },
  {
    title: 'Updated By',
    dataIndex: 'updated_by',
    key: 'updated_by',
    ellipsis: true,
    width: getWidth('updated_by')
  },
  {
    title: 'Updated At',
    dataIndex: 'updated_on',
    key: 'updated_on',
    ellipsis: true,
    render: (date) => <span>{GetDateTimeFromISO(date)}</span>,
    width: getWidth('updated_on')
  },
  {
    title: 'Actions',
    ellipsis: true,
    width: getWidth('actions'),
    render: (_, record) => <ActionButtons id={record.id} state={record.status} />
  }
];

// brand, buyer, seller, sale channel, modal -> approve /reject in row

/*
brand, buyer, seller, sale channel,
*/

const TP = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    ellipsis: true,
    width: getWidth('id')
  },
  {
    title: 'Type',
    dataIndex: 'file_upload_type',
    width: getWidth('file_upload_type'),
    key: 'file_upload_type',
    ellipsis: true,
    render: (value) => <span>{getLabel(value)}</span>
  },
  // {
  //   title: 'Buyer Name',
  //   ellipsis: true,
  //   width: getWidth('seller_name'),
  //   render: (record) => {
  //     return <span>{record?.request_body?.seller_name}</span>;
  //   }
  // },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    ellipsis: true,
    width: getWidth('status'),
    render: (state) => <Status state={state} />
  },
  {
    title: 'File',
    dataIndex: 'file_link',
    key: 'file_link',
    ellipsis: true,
    width: getWidth('file_link'),
    render: (link) => <Button icon={<DownloadOutlined />} onClick={() => DownloadViaLink(link)} type="link" />
  },
  {
    title: 'Created By',
    dataIndex: 'created_by',
    key: 'created_by',
    ellipsis: true,
    width: getWidth('created_by')
  },
  {
    title: 'Created At',
    dataIndex: 'created_on',
    key: 'created_on',
    ellipsis: true,
    render: (date) => <span>{GetDateTimeFromISO(date)}</span>,
    width: getWidth('created_on')
  },
  {
    title: 'Updated By',
    dataIndex: 'updated_by',
    key: 'updated_by',
    ellipsis: true,
    width: getWidth('updated_by')
  },
  {
    title: 'Updated At',
    dataIndex: 'updated_on',
    key: 'updated_on',
    ellipsis: true,
    render: (date) => <span>{GetDateTimeFromISO(date)}</span>,
    width: getWidth('updated_on')
  },
  {
    title: 'Brands',
    ellipsis: false,
    width: getWidth('brands'),
    render: (record) => {
      return <span>{record?.request_body?.brand_names?.join(', ')}</span>;
    }
  },
  // moved to file level
  // {
  //   title: 'buyer',
  //   ellipsis: true,
  //   width: getWidth('buyer'),
  //   render: (_, record) => <span>{record.request_body.buyer}</span>
  // },
  {
    title: 'Sale Model',
    ellipsis: true,
    width: getWidth('sale_model'),
    render: (record) => {
      return <span>{record?.request_body?.sale_model}</span>;
    }
  },
  {
    title: 'Seller',
    ellipsis: true,
    width: getWidth('seller'),
    render: (record) => <span>{record?.request_body?.seller_name}</span>
  },
  {
    title: 'Sale Channel',
    ellipsis: true,
    width: getWidth('sale_channel'),
    render: (record) => <span>{record?.request_body?.sale_channel}</span>
  },
  {
    title: 'Actions',
    ellipsis: true,
    render: (_, record) => <ActionButtons id={record.id} state={record.status} />,
    width: getWidth('actions')
  }
];

const UAR = [
  {
    title: 'Review Type',
    dataIndex: 'review_type',
    key: 'review_type',
    ellipsis: true,
    width: getWidth('review_type'),
    render: (value) => <span>{value || '-'}</span>
  },
  {
    title: 'Review Period',
    dataIndex: 'review_period',
    key: 'review_period',
    ellipsis: true,
    width: getWidth('review_period'),
    render: (value) => <span>{value || '-'}</span>
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    ellipsis: true,
    width: getWidth('status'),
    render: (state) => <Status state={state} />
  },
  {
    title: 'Created Date',
    dataIndex: 'created_on',
    key: 'created_on',
    ellipsis: true,
    render: (date) => <span>{date ? GetDateTimeFromISO(date) : '-'}</span>,
    width: getWidth('created_on')
  },
  {
    title: 'Completed Date',
    dataIndex: 'approved_on',
    key: 'approved_on',
    ellipsis: true,
    render: (date) => (date ? <span>{GetDateTimeFromISO(date)}</span> : '-'),
    width: getWidth('approved_on')
  },
  {
    title: 'Completed By',
    dataIndex: 'approved_by',
    key: 'approved_by',
    ellipsis: true,
    width: getWidth('approved_by'),
    render: (value) => value || '-'
  }
];

const GetColumns = (type) => {
  if (type === 'por') return POR;
  if (type === 'po') return PO;
  if (type === 'po_asn') return POASN;
  if (type === 'poReturnOrder') return PO_RO;
  if (type === 'po_grn') return POGRN;
  if (type === 's_cpo') return CPL;
  if (type === 's_dso') return SOL;
  if (type === 's_iso') return ISOL;
  if (type === 'so_dgrn') return SODGRN;
  if (type === 'so_igrn') return SOIGRN;
  if (type === 'inventory') return INV;
  if (type === 'OPEN_PO_ASN') return OPEN_PO_ASN;
  if (type === 'OPEN_PO_GRN') return OPEN_PO_GRN;
  if (type === 'ro') return RO;
  if (type === 'ro_grn') return RO_GRN;
  if (type === 'users') return USERS;
  if (type === 'cogs') return COGS;
  if (type === 'transfer_pricing') return TP;
  if (type === 'user_access_review') return UAR;
  return [];
};
// eslint-disable-next-line import/prefer-default-export
export { GetColumns };

const Status = ({ state }) => (
  <Tag bordered={false} color={getColor(state)} style={{ borderRadius: '20px' }}>
    {getLabel(state)}
  </Tag>
);

// eslint-disable-next-line react/no-multi-comp
const ActionButtons = ({ id, state }) => {
  const [approveLoading, setApproveLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const navigate = useNavigate();

  const onApprove = () => {
    CallApi(
      { ...apiConfig.masters.tp.approve, path: apiConfig.masters.tp.approve.path(id) },
      undefined,
      undefined,
      setApproveLoading,
      () => navigate(0),
      (error) => message.error(getError(error))
    );
  };
  const onReject = () => {
    CallApi(
      { ...apiConfig.masters.tp.reject, path: apiConfig.masters.tp.reject.path(id) },
      undefined,
      undefined,
      setRejectLoading,
      () => navigate(0),
      (error) => message.error(getError(error))
    );
  };
  if (state === 'APPROVAL_PENDING')
    return (
      <Space>
        <Button loading={approveLoading} onClick={onApprove} type="primary">
          Approve
        </Button>
        <Button loading={rejectLoading} onClick={onReject} type="link">
          Reject
        </Button>
      </Space>
    );

  return null;
};
